import { JSX } from '@redneckz/uni-jsx';
import { isSSR } from '@redneckz/uni-jsx/lib/hooks/vue/isSSR';
const isClient = !isSSR();
export const ClientOnly = JSX(({ children }) => (isClient ? children : null));
//# sourceMappingURL=ClientOnly.js.map